import store from '~/store'

export default (to, from, next) => {
  if (!store.getters['auth/check']) {
    next({
      name: 'login',
      query: { redirect: to.fullPath }
    })
  } else {
    if (store.getters['auth/user'].access_level >= 2) {
      next()
    } else {
      next({ name: 'home' })
    }
  }
}



// WEBPACK FOOTER //
// ./resources/js/middleware/auth-seller.js